import { render, staticRenderFns } from "./NextBtn.vue?vue&type=template&id=28ca26f2&scoped=true&"
import script from "./NextBtn.vue?vue&type=script&lang=js&"
export * from "./NextBtn.vue?vue&type=script&lang=js&"
import style0 from "./NextBtn.vue?vue&type=style&index=0&id=28ca26f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ca26f2",
  null
  
)

export default component.exports